import { Component, Input, Output, OnInit, EventEmitter } from "@angular/core";

@Component({
    selector: "confirm-modal",
    template: `
        <div class="mod mod-modal" [class.is-open]="isVisible">
            <div class="mod-modal__dialog mod-modal__dialog--medium">
                <div class="mod-modal__content">
                    <span>{{ message }}</span>
                </div>
                <div class="mod-modal__footer">
                    <button class="zas-button" (click)="accept()">Ja</button>
                    <button class="zas-button" (click)="close()">Nein</button>
                </div>
            </div>
        </div>
    `,
    styleUrls: ["./zurich-style.css", "./zurich.css", "./main.css"],
})
export class ConfirmModalComponent {
    static instance: ConfirmModalComponent;

    public static open(msg: string, onAccept: () => void): void {
        if (!ConfirmModalComponent.instance) {
            return;
        }
        ConfirmModalComponent.instance.isVisible = true;
        ConfirmModalComponent.instance.message = msg;
        ConfirmModalComponent.instance.onAccept = onAccept;
    }

    isVisible = false;
    message = "Möchten Sie fortfahren?";
    onAccept: () => void;

    constructor() {
        ConfirmModalComponent.instance = this;
    }

    public accept(): void {
        this.close();
        setTimeout(() => this.onAccept());
    }

    public close(): void {
        this.isVisible = false;
    }
}
